
import { getCookie, setCookie } from '@/public/functions';

export const smbTracking = (cat, pixelID) => {


    if (uri.includes('-dwa')) {
        if (cat == undefined) return;
        var axel = Math.random() + "";
        var a = axel * 10000000000000;
        $('body').append('<iframe src="https://8131660.fls.doubleclick.net/activityi;src=8131660;type=ooma20;cat=' + cat + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1;num=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');
        // console.log('submited dwa tracking pixel ' + cat);
    } else if (uri.includes('-ifg')) {

        // var url     = this.url;
        if (pixelID === undefined) return;

        (function (pixelID) {

            // console.log('info group pixel: ' + pixelID);
            var callback = function () {
                if (typeof (url) != 'undefined') {
                    window.location = url;
                }
            };
            gtag('event', 'conversion', {
                'send_to': pixelID,
                'event_callback': callback
            });
            return false;

        })(pixelID);

    }


}

